'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

const modalTargetClasses = [
  'order-modal',
  'archive-photo-modal',
];

export function GlobalModalEscape() {
  const router = useRouter();

  useEffect(() => {
    function closeRouteModal() {
      const modal = document.querySelector<HTMLElement>('[data-modal-close-href]');
      const closeHref = modal?.dataset.modalCloseHref;
      if (!closeHref) return false;
      router.push(closeHref, { scroll: false });
      return true;
    }

    function closeHashModal() {
      if (!window.location.hash) return false;
      const target = document.getElementById(decodeURIComponent(window.location.hash.slice(1)));
      if (!target || !modalTargetClasses.some(className => target.classList.contains(className))) return false;
      target.classList.add('modal-closing');
      window.history.replaceState('', document.title, window.location.pathname + window.location.search);
      return true;
    }

    function handleKeyDown(event: KeyboardEvent) {
      if (event.key !== 'Escape') return;

      let handled = false;
      handled = closeRouteModal() || handled;
      handled = closeHashModal() || handled;

      if (handled) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        return;
      }

      for (const dialog of Array.from(document.querySelectorAll<HTMLDialogElement>('dialog[open]'))) {
        dialog.close();
        handled = true;
      }
      for (const details of Array.from(document.querySelectorAll('details[open]'))) {
        details.removeAttribute('open');
        handled = true;
      }

      document.dispatchEvent(new CustomEvent('regal:close-modals'));

      if (handled) event.preventDefault();
    }

    function clearClosingState() {
      document.querySelectorAll('.modal-closing').forEach(element => element.classList.remove('modal-closing'));
    }

    document.addEventListener('keydown', handleKeyDown, { capture: true });
    window.addEventListener('hashchange', clearClosingState);
    return () => {
      document.removeEventListener('keydown', handleKeyDown, { capture: true });
      window.removeEventListener('hashchange', clearClosingState);
    };
  }, [router]);

  return null;
}
